import { getInstance } from '@/auth/index.js'
import { authGuard } from '@/guards/auth.js'
import HAS_CHILD_COMPANY from '@/queries/HasChildCompany.gql'

const hasChildCompany = async (apollo) => {
  const { data } = await apollo.defaultClient.query({
    query: HAS_CHILD_COMPANY,
    fetchPolicy: 'cache-first',
  })
  return data?.hasChildCompany || false
}

export function masterGuard(apolloProvider) {
  return async (to, from, next) => {
    const authService = getInstance()

    await authGuard(async () => {
      const masterRouteNames = [
        'master-dashboard',
        'master-leads',
        'master-lead-details',
        'master-valuation',
      ]

      if (masterRouteNames.includes(to.name)) {
        const parentCompany = await hasChildCompany(apolloProvider)
        if (authService.isAuthenticated && parentCompany) {
          next()
          return
        }
        next({ name: 'dashboard', replace: true })
        return
      }
      next()
    })
  }
}
